// removed by extract-text-webpack-plugin
module.exports = {"root":"Footer__root__1UUMy","content":"Footer__content__2oleg","brandContainer":"Footer__brandContainer__1m1Bv","brandLogo":"Footer__brandLogo__TvoY6","brandText":"Footer__brandText__3-6y3","linkSection":"Footer__linkSection__219x7","linksContainer":"Footer__linksContainer__1lj46","sectionTitle":"Footer__sectionTitle__LHfnQ","link":"Footer__link__3qHjF","icon":"Footer__icon__bF0OS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 1818
// module chunks = 0